import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { Breadcrumb } from 'app/shared';
import { t } from 'i18next';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { MedicalCenterDetailTab } from './MedicalCenterDetailTab';
import { MedicalCenterStatisticsTab } from './MedicalCenterStatisticsTab';

export const MedicalCenterDetail = () => {
  const { id } = useParams();
  const [tab, setTab] = useState('0');
  const handleTabChange = (_event: any, newValue: string) => {
    setTab(newValue);
  };

  return (
    <>
      <Breadcrumb />
      <TabContext value={tab}>
        <TabList onChange={handleTabChange} centered>
          <Tab label={t('common.detail')} value="0" />
          <Tab label={t('medicalCenter.statistics')} value="1" />
        </TabList>
        <TabPanel value="0">
          <MedicalCenterDetailTab id={id as string} />
        </TabPanel>
        <TabPanel value="1">
          <MedicalCenterStatisticsTab id={id as string} />
        </TabPanel>
      </TabContext>
    </>
  );
};
